import { Navigate, Route, Routes } from 'react-router-dom';

import ApplyTab from 'pages/GetCertified/Tabs/ApplyTab/ApplyTab';
import BillingAndPaymentTab from 'pages/Profile/Tabs/BillingAndPaymentTab/BillingAndPaymentTab';
import ClassesTab from 'pages/Organization/Tabs/ClassesTab/ClassesTab';
import CookiePolicyPage from 'pages/Policies/CookiePolicyPage/CookiePolicyPage';
import EditOrganization from 'pages/Admin/Organizations/EditOrganization/EditOrganization';
import EditTrackmanParameter from 'pages/Admin/TrackmanParameters/EditTrackmanParameter/EditTrackmanParameter';
import { EventsListNew } from 'pages/Admin/TrackmanEvents/components/EventsList/EventsList';
import GetCertified from 'pages/GetCertified/GetCertified';
import HomePage from 'pages/HomePage/HomePage';
import ManageUserData from 'pages/Admin/ManageUserData/ManageUserData';
import NoAccess from 'pages/ErrorPages/NoAccess/NoAccess';
import NotFound from 'pages/ErrorPages/NotFound/NotFound';
import OrganizationsList from 'pages/Admin/Organizations/OrganizationsList/OrganizationsList';
import PlayerInformationTab from 'pages/Profile/Tabs/PlayerInformationTab/PlayerInformationTab';
import PlayerSettingsTab from 'pages/Profile/Tabs/PlayerSettingsTab/PlayerSettingsTab';
import PrivacyPolicyPage from 'pages/Policies/PrivacyPolicyPage/PrivacyPolicyPage';
import Profile from 'pages/Profile/Profile';
import SubscriptionsTab from 'pages/Profile/Tabs/SubscriptionsTab/SubscriptionsTab';
import TermsAndConditionsPage from 'pages/Policies/TermsAndConditionsPage/TermsAndConditionsPage';
import TestInvitations from 'pages/Admin/TestInvitations/TestInvitations';
import TourAverages from 'pages/Admin/TourAverages/TourAverages';
import TranslatorPage from 'pages/Admin/TranslatorPage/TranslatorPage';
import { ModuleDetailsPage } from 'pages/LearningHub/ModuleDetails/ModuleDetails';
import { ModuleLibrary } from 'pages/LearningHub/ModuleLibrary/ModuleLibrary';
import { ModuleList } from 'pages/Admin/Modules/ModuleList/ModuleList';
import { ModuleList as ModuleListV2 } from 'pages/Admin/ModulesV2/ModuleList/ModuleList';
import { ModuleItem as ModuleItemV2 } from 'pages/Admin/ModulesV2/ModuleItem/ModuleItem';
import { EditGeneral as EditGeneralV2 } from 'pages/Admin/ModulesV2/EditGeneral/EditGeneral';
import { EditChapters as EditChaptersV2 } from 'pages/Admin/ModulesV2/EditChapters/EditChapters';
import { EditCertifications as EditCertificationsV2 } from 'pages/Admin/ModulesV2/EditCertifications/EditCertifications';
import { EditGeneral } from 'pages/Admin/Modules/EditGeneral/EditGeneral';
import { ModuleItem } from 'pages/Admin/Modules/ModuleItem/ModuleItem';
import { EditChapters } from 'pages/Admin/Modules/EditChapters/EditChapters';
import { EditCertifications } from 'pages/Admin/Modules/EditCertifications/EditCertifications';
import { LearningModule } from 'pages/LearningHub/LearningModule/LearningModule';
import { TrackmanEvents } from 'pages/TrackmanEvents/TrackmanEvents';
import { TrackmanParameters } from 'pages/TrackmanParameters/TrackmanParameters';
import { Organization } from 'pages/Organization/Organization';
import { ProgressTab } from 'pages/Organization/Tabs/ProgressTab/ProgressTab';
import { Cart } from 'pages/Webshop/Cart/Cart';
import { Shop } from 'pages/Webshop/Shop/Shop';
import { LandingPage } from 'pages/LandingPage/LandingPage';
import StudentsTab from 'pages/Organization/Tabs/StudentsTab/StudentsTab';
import { MastersTab } from 'pages/GetCertified/Tabs/MastersTab/MastersTab';
import { PartnersTab } from 'pages/GetCertified/Tabs/PartnersTab/PartnersTab';
import { MastersList } from 'pages/Admin/Masters/MastersList/MastersList';
import { EditMaster } from 'pages/Admin/Masters/EditMaster/EditMaster';
import { EditPartner } from 'pages/Admin/Partners/EditPartner/EditPartner';
import { PartnersList } from 'pages/Admin/Partners/PartnersList/PartnersList';
import { TrackmanParametersList } from 'pages/Admin/TrackmanParameters/TrackmanParametersList/TrackmanParametersList';
import { Analytics } from 'pages/Admin/Analytics/Analytics';
import OverviewTab from 'pages/Admin/Analytics/Tabs/OverviewTab/OverviewTab';
import { OrganizationTab } from 'pages/Admin/Analytics/Tabs/OrganizationTab/OrganizationTab';
import { WebinarsTab } from 'pages/Admin/Analytics/Tabs/WebinarsTab/WebinarsTab';
import { EventEditor } from 'pages/Admin/TrackmanEvents/EventEditor/EventEditor';

export const CertificationsTabsRelativeRoutes = {
  Partners: 'Partners',
  Masters: 'Masters',
  ApplyForMaster: 'ApplyForMaster',
} as const;

export const ProfileTabsRelativeRoutes = {
  PlayerInformation: 'PlayerInformation',
  PlayerSettings: 'PlayerSettings',
  BillingAndPayment: 'BillingAndPayment',
  Subscriptions: 'Subscriptions',
} as const;

export const OrganizationTabsRelativeRoutes = {
  Progress: 'Progress',
  Students: 'Students',
  Classes: 'Classes',
} as const;

export const AdminPagesRelativeRoutes = {
  ModuleList: 'ModuleList',
  ModulesV2: 'ModulesV2',
  ModuleItem: 'ModuleEditor',
  EditModuleItem: 'ModuleEditor/:moduleId',
  User: 'User',
  Translation: 'Translation',
  OrganizationsList: 'Organizations',
  OrganizationsEditor: 'OrganizationsEditor',
  EditOrganizationItem: 'OrganizationsEditor/:organizationId',
  TestInvitations: 'TestInvitations',
  TestOneTimePayments: 'TestOneTimePayments',
  TrackmanParametersList: 'TrackmanParameters',
  TrackmanParametersEditor: 'TrackmanParametersEditor',
  EditTrackmanParameter: 'TrackmanParametersEditor/:parameterId',
  PartnersList: 'Partners',
  PartnersEditor: 'PartnersEditor',
  EditParter: 'PartnersEditor/:partnerId',
  MastersList: 'Masters',
  MastersEditor: 'MastersEditor',
  EditMaster: 'MastersEditor/:masterId',
  TourAverages: 'TourAverages',
  EventsList: 'Events',
  EventEditor: 'EventEditor',
  EditEventItem: 'EventEditor/:eventId',
  Analytics: 'Analytics',
} as const;

export const AnalyticsTabsRelativeRoutes = {
  Overview: 'Overview',
  Organizations: 'Organizations',
  Webinars: 'Webinars',
} as const;

export const LearningHubTabs = {
  Modules: 'Modules',
  LearningHubCertifications: 'Certifications',
};

export const LearningHubRelativeRoutes = {
  ...LearningHubTabs,
  ModuleDetails: 'LearningHub/Modules/:slug',
  LearningModule: 'LearningHub/Modules/:slug/Module',
} as const;

export const AdminModuleTabs = {
  EditGeneral: 'General',
  EditChapters: 'Chapters',
  EditCertifications: 'Certifications',
};

export const WebshopRelativeRoutes = {
  Cart: 'Webshop/Cart',
} as const;

export const AdminModuleRelativeRoutes = AdminModuleTabs;

export const AdminModulesV2RelativeRoutes = {
  ModuleItem: 'ModuleEditor',
  EditModuleItem: 'ModuleEditor/:moduleId',
} as const;

// Only absolute paths — relative route segments live in their own typed objects above.
export const DefaultRoutes = {
  LandingPage: '/',

  Home: '/Home',
  TrackmanParameters: '/TrackmanParameters',
  LearningHub: '/LearningHub',
  Webshop: '/Webshop',
  Certifications: '/MastersAndPartners',
  PurchaseMembership: '/PurchaseMembership',
  TrackmanEvents: '/TrackmanEvents',
  Organization: '/Organization',
  Admin: '/Admin',
  Profile: '/Profile',
  CookiePolicy: '/CookiePolicy',
  TermsAndConditions: '/TermsAndConditions',
  Pricing: '/Pricing',
  PrivacyPolicy: '/PrivacyPolicy',
  NotFound: '/NotFound',
  NoAccess: '/NoAccess',
} as const;

export type DefaultRouteKey = keyof typeof DefaultRoutes;

const learningHubRoutes = (
  <>
    <Route path={DefaultRoutes.LearningHub} element={<ModuleLibrary />} />
    <Route path={LearningHubRelativeRoutes.ModuleDetails} element={<ModuleDetailsPage />} />
    <Route path={LearningHubRelativeRoutes.LearningModule} element={<LearningModule />} />
  </>
);

const webshopRoutes = (
  <>
    <Route path={DefaultRoutes.Webshop} element={<Shop />} />
    <Route path={WebshopRelativeRoutes.Cart} element={<Cart />}></Route>
  </>
);

const adminModuleRoutes = (
  <>
    <Route path={AdminPagesRelativeRoutes.ModuleItem} element={<ModuleItem />}>
      <Route index element={<EditGeneral />} />
      <Route path={AdminModuleRelativeRoutes.EditGeneral} element={<EditGeneral />} />
      <Route path={AdminModuleRelativeRoutes.EditChapters} element={<EditChapters />} />
      <Route path={AdminModuleRelativeRoutes.EditCertifications} element={<EditCertifications />} />
    </Route>
    <Route path={AdminPagesRelativeRoutes.EditModuleItem} element={<ModuleItem />}>
      <Route index element={<EditGeneral />} />
      <Route path={AdminModuleRelativeRoutes.EditGeneral} element={<EditGeneral />} />
      <Route path={AdminModuleRelativeRoutes.EditChapters} element={<EditChapters />} />
      <Route path={AdminModuleRelativeRoutes.EditCertifications} element={<EditCertifications />} />
    </Route>
  </>
);

const adminModuleV2Routes = (
  <>
    <Route path={`${AdminPagesRelativeRoutes.ModulesV2}/${AdminModulesV2RelativeRoutes.ModuleItem}`} element={<ModuleItemV2 />}>
      <Route index element={<EditGeneralV2 />} />
      <Route path={AdminModuleRelativeRoutes.EditGeneral} element={<EditGeneralV2 />} />
      <Route path={AdminModuleRelativeRoutes.EditChapters} element={<EditChaptersV2 />} />
      <Route path={AdminModuleRelativeRoutes.EditCertifications} element={<EditCertificationsV2 />} />
    </Route>
    <Route path={`${AdminPagesRelativeRoutes.ModulesV2}/${AdminModulesV2RelativeRoutes.EditModuleItem}`} element={<ModuleItemV2 />}>
      <Route index element={<EditGeneralV2 />} />
      <Route path={AdminModuleRelativeRoutes.EditGeneral} element={<EditGeneralV2 />} />
      <Route path={AdminModuleRelativeRoutes.EditChapters} element={<EditChaptersV2 />} />
      <Route path={AdminModuleRelativeRoutes.EditCertifications} element={<EditCertificationsV2 />} />
    </Route>
  </>
);

export const routes = (
  <Routes>
    <Route index element={<LandingPage />} />
    <Route path={DefaultRoutes.LandingPage} element={<LandingPage />} />
    <Route path={DefaultRoutes.Home} element={<HomePage />} />
    {learningHubRoutes}
    {webshopRoutes}
    <Route path={DefaultRoutes.TrackmanParameters} element={<TrackmanParameters />} />

    <Route path={DefaultRoutes.Certifications} element={<GetCertified />}>
      <Route index element={<PartnersTab />} />
      {/* <Route path={DefaultRoutes.Certificate} element={<CertificateTab />} /> */}
      <Route path={CertificationsTabsRelativeRoutes.ApplyForMaster} element={<ApplyTab />} />
      <Route path={CertificationsTabsRelativeRoutes.Partners} element={<PartnersTab />} />
      <Route path={CertificationsTabsRelativeRoutes.Masters} element={<MastersTab />} />
    </Route>
    <Route path={DefaultRoutes.TrackmanEvents} element={<TrackmanEvents />} />
    <Route path={DefaultRoutes.Profile} element={<Profile />}>
      <Route index element={<PlayerInformationTab />} />
      <Route path={ProfileTabsRelativeRoutes.PlayerInformation} element={<PlayerInformationTab />} />
      <Route path={ProfileTabsRelativeRoutes.PlayerSettings} element={<PlayerSettingsTab />} />
      <Route path={ProfileTabsRelativeRoutes.BillingAndPayment} element={<BillingAndPaymentTab />} />
      <Route path={ProfileTabsRelativeRoutes.Subscriptions} element={<SubscriptionsTab />} />
    </Route>
    <Route path={DefaultRoutes.Organization} element={<Organization />}>
      <Route index element={<ProgressTab />} />
      <Route path={OrganizationTabsRelativeRoutes.Progress} element={<ProgressTab />} />
      <Route path={OrganizationTabsRelativeRoutes.Students} element={<StudentsTab />} />
      <Route path={OrganizationTabsRelativeRoutes.Classes} element={<ClassesTab />} />
    </Route>
    <Route path={DefaultRoutes.Admin}>
      <Route index element={<ModuleList />} />
      <Route path={AdminPagesRelativeRoutes.ModuleList} element={<ModuleList />} />
      <Route path={AdminPagesRelativeRoutes.ModulesV2} element={<ModuleListV2 />} />
      {adminModuleRoutes}
      {adminModuleV2Routes}
      <Route path={AdminPagesRelativeRoutes.OrganizationsList} element={<OrganizationsList />} />
      <Route path={AdminPagesRelativeRoutes.OrganizationsEditor} element={<EditOrganization />} />
      <Route path={AdminPagesRelativeRoutes.EditOrganizationItem} element={<EditOrganization />} />
      <Route path={AdminPagesRelativeRoutes.TrackmanParametersList} element={<TrackmanParametersList />} />
      <Route path={AdminPagesRelativeRoutes.TrackmanParametersEditor} element={<EditTrackmanParameter />} />
      <Route path={AdminPagesRelativeRoutes.EditTrackmanParameter} element={<EditTrackmanParameter />} />
      <Route path={AdminPagesRelativeRoutes.User} element={<ManageUserData />} />
      <Route path={AdminPagesRelativeRoutes.Translation} element={<TranslatorPage />} />
      <Route path={AdminPagesRelativeRoutes.TestInvitations} element={<TestInvitations />} />
      <Route path={AdminPagesRelativeRoutes.PartnersList} element={<PartnersList />} />
      <Route path={AdminPagesRelativeRoutes.PartnersEditor} element={<EditPartner />} />
      <Route path={AdminPagesRelativeRoutes.EditParter} element={<EditPartner />} />
      <Route path={AdminPagesRelativeRoutes.MastersList} element={<MastersList />} />
      <Route path={AdminPagesRelativeRoutes.MastersEditor} element={<EditMaster />} />
      <Route path={AdminPagesRelativeRoutes.EditMaster} element={<EditMaster />} />
      <Route path={AdminPagesRelativeRoutes.TourAverages} element={<TourAverages />} />
      {/* <Route path={AdminPagesRelativeRoutes.EventsList} element={<EventsList />} /> */}
      <Route path={AdminPagesRelativeRoutes.EventsList} element={<EventsListNew />} />

      <Route path={AdminPagesRelativeRoutes.EventEditor} element={<EventEditor />} />
      <Route path={AdminPagesRelativeRoutes.EditEventItem} element={<EventEditor />} />
      <Route path={AdminPagesRelativeRoutes.Analytics} element={<Analytics />}>
        <Route index element={<OverviewTab />} />
        <Route path={AnalyticsTabsRelativeRoutes.Overview} element={<OverviewTab />} />
        <Route path={AnalyticsTabsRelativeRoutes.Organizations} element={<OrganizationTab />} />
        <Route path={AnalyticsTabsRelativeRoutes.Webinars} element={<WebinarsTab />} />
      </Route>
    </Route>
    <Route path={DefaultRoutes.Profile} element={<Profile />} />
    <Route path={DefaultRoutes.CookiePolicy} element={<CookiePolicyPage />} />
    <Route path={DefaultRoutes.TermsAndConditions} element={<TermsAndConditionsPage />} />
    <Route path={DefaultRoutes.PrivacyPolicy} element={<PrivacyPolicyPage />} />
    <Route path={DefaultRoutes.NoAccess} element={<NoAccess />} />
    <Route path={DefaultRoutes.NotFound} element={<NotFound />} />
    <Route path='*' element={<Navigate to={DefaultRoutes.NotFound} />} />
  </Routes>
);
